import api from '../../../services/api';
import { normalizeReleaseNotes, ReleaseNoteEntry } from '../../../dto/releaseNotes';

/** „Co nowego”: business changelog, readable by every signed-in role. */
export async function fetchReleaseNotes(): Promise<ReleaseNoteEntry[]> {
  const response = await api.get('/release-notes');
  return normalizeReleaseNotes(response.data);
}
